import React from 'react';
import { SkeletonTable, SkeletonText } from 'ui/components/skeleton';

export const Item = ({ data, isLoading }) => {
  return (
    <section className="border rounded-2 p-3 pt-2 mb-3" id="items">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {isLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Rincian Item'
        )}
      </div>
      <div className="pt-2">
        {isLoading ? (
          <SkeletonTable headerCount={3} bodyCount={4} />
        ) : (
          <div className="table-responsive">
            <table
              width="100%"
              className="table table-hover table-vcenter card-table datatable border"
            >
              <thead className="bg-light">
                <tr className="th">
                  <td style={{ whiteSpace: 'initial', width: '200px' }}>
                    Item
                  </td>
                  <td
                    style={{
                      whiteSpace: 'initial',
                      width: '200px',
                      textAlign: 'end',
                    }}
                  >
                    Quantity Planned
                  </td>
                  {(data?.receiving_status === 'disputed' || data?.receiving_status === 'received') &&
                    <td
                      style={{
                        whiteSpace: 'initial',
                        width: '200px',
                        textAlign: 'end',
                      }}
                    >
                      Quantity Receive
                    </td>
                  }
                </tr>
              </thead>
              <tbody>
                {data?.items?.map((s, i) => (
                  <tr key={i}>
                    <td style={{ whiteSpace: 'initial', width: '200px' }}>
                      <div className="table-col text-uppercase">
                        <div className="fs-8 fw-semibold">
                          {s?.item?.alias_name}
                        </div>
                        <small className="info text-ellipsis">{s?.item?.code}</small>
                      </div>
                    </td>
                    <td
                      style={{
                        whiteSpace: 'initial',
                        width: '150px',
                        textAlign: 'end',
                      }}
                    >
                      <span className='fw-semibold fs-8 d-block'>{s?.quantity_planned} {s?.item?.default_fraction}</span>
                      <span className='fs-9 d-block'>{s?.quantity_planned_fracted}</span>
                    </td>
                    {(data?.receiving_status === 'disputed' || data?.receiving_status === 'received') &&
                      <td
                        style={{
                          whiteSpace: 'initial',
                          width: '150px',
                          textAlign: 'end',
                        }}
                      >
                        <span className={`fw-semibold fs-8 d-block ${(s?.quantity_planned !== s?.quantity_received) ? 'text-danger': 'text-success'}`}>{s?.quantity_received} {s?.item?.default_fraction}</span>
                        <span className='fs-9 d-block'>{s?.quantity_received_fracted}</span>
                      </td>
                    }
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};
